import React from 'react';
import {Badge} from './badges/Badge';
import {CampaignSaleBadge} from './badges/CampaignSaleBadge';
import {DropBadge} from './badges/DropBadge';
import {InBasketBadge} from './badges/InBasketBadge';
import {PersonalizedBadge} from './badges/PersonalisedBadge';
import {SaleBadge} from './badges/SaleBadge';
import {SpecialSizesBadge} from './badges/SpecialSizesBadge';
import {Upcycled} from './badges/Upcycled';
import {BadgeComponentType, getBadgesToDisplay} from './helpers';
import {BadgeListProps} from './types';

const BadgeComponentMap: Record<
  BadgeComponentType,
  React.ComponentType<any>
> = {
  [BadgeComponentType.BREAST_FEEDING_CAPABLE]: Badge,
  [BadgeComponentType.CAMPAIGN_SALE]: CampaignSaleBadge,
  [BadgeComponentType.KIDS]: Badge,
  [BadgeComponentType.NEW]: Badge,
  [BadgeComponentType.PACK]: Badge,
  [BadgeComponentType.PERSONALISED]: PersonalizedBadge,
  [BadgeComponentType.PREMIUM]: Badge,
  [BadgeComponentType.SALE]: SaleBadge,
  [BadgeComponentType.SIMILAR]: Badge,
  [BadgeComponentType.EXCLUSIVE]: Badge,
  [BadgeComponentType.SPECIAL_SIZES]: SpecialSizesBadge,
  [BadgeComponentType.SPONSORED]: Badge,
  [BadgeComponentType.IN_BASKET]: InBasketBadge,
  [BadgeComponentType.SECOND_HAND]: Badge,
  [BadgeComponentType.EXA_DROP]: DropBadge,
  [BadgeComponentType.DROP_EXCLUSIVE]: DropBadge,
  [BadgeComponentType.SNEAKER_RELEASE_CALENDER]: DropBadge,
  [BadgeComponentType.UPCYCLED]: Upcycled,
  [BadgeComponentType.UNIQUE]: Badge,
  [BadgeComponentType.BRAND_HAND_PICKED]: Badge,
  [BadgeComponentType.SECOND_LOVE]: Badge,
};

export const BadgeList: React.FC<BadgeListProps> = props => {
  const {
    isDisplayedInProductTile = true,
    productIsInBasket,
    translations,
  } = props;

  const badgesToDisplay = getBadgesToDisplay(props);

  return (
    <>
      {badgesToDisplay.map(({componentType, props: badgeProps}, index) => {
        const BadgeComponent = BadgeComponentMap[componentType];
        return (
          <BadgeComponent
            {...badgeProps}
            dataTestId={`badge-${componentType}`}
            key={index}
            isDisplayedInProductTile={isDisplayedInProductTile}
            name={componentType}
          />
        );
      })}

      {productIsInBasket ? (
        <InBasketBadge
          dataTestId={`badge-${BadgeComponentType.IN_BASKET}`}
          name="basket"
          isDisplayedInProductTile={isDisplayedInProductTile}
          text={translations.inBasket}
        />
      ) : null}
    </>
  );
};

export default React.memo(BadgeList);
